export default "__VITE_ASSET__B9E_C9UV__"